import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dental/frontend/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CtaBand"] */ "/var/www/dental/frontend/src/components/marketing/CtaBand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GemFrame"] */ "/var/www/dental/frontend/src/components/marketing/GemFrame.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Counter"] */ "/var/www/dental/frontend/src/components/marketing/motion/Counter.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/dental/frontend/src/components/marketing/motion/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageHero"] */ "/var/www/dental/frontend/src/components/marketing/PageHero.tsx");
